import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate, Link } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import { adminApi } from '@/lib/api'
import { ThemePresetForm } from './_form'
import type { ThemePresetFormValues } from './_form'

export default function CreateThemePresetPage() {
  const qc = useQueryClient()
  const navigate = useNavigate()

  const createPreset = useMutation({
    mutationFn: (data: ThemePresetFormValues) => adminApi.themePresets.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['admin', 'theme-presets'] })
      navigate('/theme-presets')
    },
  })

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Link
          to="/theme-presets"
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
        >
          <ChevronLeft className="h-4 w-4" />
          Kembali
        </Link>
      </div>

      <div>
        <h1 className="text-2xl font-bold">Buat Tema Preset</h1>
        <p className="text-sm text-muted-foreground">
          Atur warna, font, dan layout halaman default untuk tema baru.
        </p>
      </div>

      <ThemePresetForm
        onSubmit={(values) => createPreset.mutate(values)}
        isSaving={createPreset.isPending}
        saveError={createPreset.error?.message ?? null}
        submitLabel="Buat Tema"
      />
    </div>
  )
}
